<template>
	<!-- Modal -->
	<div class="modal fade" id="createQuestionnaireModal" tabindex="-1" aria-labelledby="createQuestionnaireModalLabel" aria-hidden="true">
		<form @submit.prevent="createQuestionnaire">
			<div class="modal-dialog">
				<div class="modal-content">
                    <div v-for="(errorArray, idx) in validation_errors" :key="idx" class="alert alert-warning" role="alert">
                        <div v-for="(allErrors, idx) in errorArray" :key="idx">
                            {{ allErrors }}
                        </div>
                    </div>

					<div class="modal-header">
						<h5 class="modal-title" id="createQuestionnaireModalLabel">{{ __('questionnaires.new') }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="mb-3">
							<label for="name" class="form-label">{{ __('questionnaires.name') }}</label>
							<input type="text" class="form-control" v-model="form.name" id="name" required>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ __('actions.close') }}</button>
						<button type="submit" class="btn btn-primary">{{ __('actions.submit') }}</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {
				name: '',
				questions: []
			},
            validation_errors: ''
		}
	},

	methods: {
		createQuestionnaire() {
			axios.post('/questionnaires', this.form).then(response => {
				const myModalEl = document.querySelector('#createQuestionnaireModal')
				const modal = bootstrap.Modal.getOrCreateInstance(myModalEl)
				modal.hide()
				this.form.name = ''
				window.location.href = '/questionnaires/' + response.data.questionnaire.id + '/edit'
			}).catch(e => {
                this.validation_errors = e.response.data.errors
			});
		}
	}
}
</script>
